/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { useEffect, useState } from "react";
import { saveTratamiento } from "../../services/TratamientoService";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";
import { generaCodigo } from "../../utils/utils";

const initialState = {
  codigo: "",
  descripcion: "TRATAMIENTO",
  idTrTipo: null,
  idTrMarca: null,
  tiempoProduccion: "",
  observaciones: "",
};

const nameItemText = "Tratamiento";
const itemGender = "M";
//
// ########################################################################### 
//
const TratamientoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [trTipos, setTrTipos] = useState([]);
  const [trMarcas, setTrMarcas] = useState([]);
  const [valueACTrTipo, setValueACTrTipo] = useState(itemCrud.trTipo);
  const [inputValueACTrTipo, setInputValueACTrTipo] = useState("");
  const [valueACTrMarca, setValueACTrMarca] = useState(itemCrud.trMarca)
  const [inputValueACTrMarca, setInputValueACTrMarca] = useState("");

  //
  // ################################################################################
  //
  useEffect(() => {
    loadTrTipos();
    loadTrMarcas();
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
      setItemCrudLocal({
        ...itemCrudLocal,
        codigo: generaCodigo(),
      });
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const loadTrTipos = async () => {
    const response = await getCacheData("tr_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setTrTipos(_var);
    } else {
      setTrTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTrMarcas = async () => {
    const response = await getCacheData("tr_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setTrMarcas(_var);
    } else {
      setTrMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción del Tratamiento",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.idTrTipo === "" || itemCrudLocal.idTrTipo === null) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.idTrMarca === "" || itemCrudLocal.idTrMarca === null) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar la Marca",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.tiempoProduccion === "" || itemCrudLocal.tiempoProduccion <= 0) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el Tiempo de producción",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      codigo: itemCrudLocal.codigo,
      descripcion: itemCrudLocal.descripcion,
      id_tr_tipo: valueACTrTipo.id,
      id_tr_marca: valueACTrMarca.id,
      tiempo_produccion: +itemCrudLocal.tiempoProduccion,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrud.id;
    }

    setIsDoingSomething(true);
    const response = await saveTratamiento(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="codigo"
                label="Código"
                variant="outlined"
                size="small"
                name="codigo"
                value={itemCrudLocal.codigo}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={10}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                // disabled={actionCrud === "disable" || actionCrud === "enable"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={5}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-tipo"
                size="small"
                value={
                  valueACTrTipo && valueACTrTipo.id
                    ? valueACTrTipo
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACTrTipo(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idTrTipo: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACTrTipo}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTrTipo(newInputValue);
                }}
                options={trTipos}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              // evita que abra/cierre el dropdown
                              e.stopPropagation();
                              loadTrTipos();
                            }}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={5}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-marca"
                size="small"
                value={
                  valueACTrMarca && valueACTrMarca.id
                    ? valueACTrMarca
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACTrMarca(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idTrMarca: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACTrMarca}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTrMarca(newInputValue);
                }}
                options={trMarcas}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Marca"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              // evita que abra/cierre el dropdown
                              e.stopPropagation();
                              loadTrMarcas();
                            }}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={2}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="tiempoProduccion"
                label="Tiempo de Producción (días)"
                variant="outlined"
                size="small"
                name="tiempoProduccion"
                value={itemCrudLocal.tiempoProduccion ? itemCrudLocal.tiempoProduccion : 0}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TratamientoDialog;
